const operatorData=['+','-']

export default operatorData